<i18n>
{
  "ru": {
    "title": "Обувь {city}",
    "cities": {
      "kiev": "Киев",
      "dp": "Днепр"
    }
  },
  "uk": {
    "title": "Взуття {city}",
    "cities": {
      "kiev": "Київ",
      "dp": "Дніпро"
    }
  }
}
</i18n>

<template>
  <div id="app">
    <Top />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Top from "@/views/Top.vue";
import Footer from "@/views/Footer.vue";

export default {
  metaInfo() {
    let zone = "dp";
    switch (window.location.hostname.split(".")[1]) {
      case "kiev":
        zone = "kiev";
        break;
      case "od":
        zone = "od";
        break;
    }
    return {
      title: this.$t("title", { city: this.$t(`cities.${zone}`) })
    };
  },
  created: function() {
    this.$auth.isAuth(this.$store);
    this.$store.dispatch("loadAllData");
  },
  components: {
    Top,
    Footer
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700,800&amp;subset=cyrillic");
</style>
<style src="bootstrap/dist/css/bootstrap.css"></style>
<style src="bootstrap-vue/dist/bootstrap-vue.css"></style>
<style src="@/assets/css/core.css"></style>
<style src="@/assets/css/cropper.css"></style>
